import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./scenes/Home";
import Header from "./components/Header";
import AboutPage from "./scenes/About";
import TermsAndConditions from "./scenes/TermsAndConditions";
import ContactSupport from "./scenes/ContactSupport";
import Subscription from "./scenes/Subcription";
import { GamePage } from "./scenes/GamePage";
import Footer from "./components/Footer";
import PrivacyPolicy from "./scenes/PrivacyPolicy";
import FAQ from "./scenes/FAQ";
import NotFound from "./scenes/NotFound";
import DownloadApp from "./scenes/Download";
import CommunityGuidelines from "./scenes/CommunityGuidlines";
import HowToPlay from "./scenes/HowToPlay";

function App() {

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/game/:id" element={<GamePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/contact" element={<ContactSupport />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/faqs" element={<FAQ />} />
        <Route path="/download" element={<DownloadApp />} />
        <Route path="/community-guidelines" element={<CommunityGuidelines />} />
        <Route path="/how-to-play" element={<HowToPlay />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
